import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";

import { Typography } from "../Typography/Typography";
import { STATUS } from "../types";

const statusColorBadgeText: Record<STATUS, string> = {
  [STATUS.SUCCESS]: color.green[400],
  [STATUS.WARN]: color.yellow[400],
  [STATUS.ERROR]: color.red[400],
  [STATUS.INFO]: color.blue[400],
  [STATUS.NONE]: color.neutral[400],
  [STATUS.NEUTRAL]: color.neutral[400],
  [STATUS.PURPLE]: color.purple[300],
};

const statusColorBadgeBackground: Record<STATUS, string> = {
  [STATUS.SUCCESS]: color.green[100],
  [STATUS.WARN]: color.yellow[100],
  [STATUS.ERROR]: color.red[100],
  [STATUS.INFO]: color.blue[100],
  [STATUS.NONE]: color.neutral[100],
  [STATUS.NEUTRAL]: color.neutral[200],
  [STATUS.PURPLE]: color.purple[100],
};

interface Props {
  status: STATUS;
  statusText?: string;
  type?: "default" | "subtle";
}

export const StatusBadge: React.FC<Props> = (props) => {
  const { status, statusText, type = "default" } = props;

  if (status === STATUS.NONE) {
    return null;
  }

  return (
    <Badge type={type} status={status}>
      <Typography variant="bodySmall" color="inherit">
        {statusText}
      </Typography>
    </Badge>
  );
};

const Badge = styled.span<{ status: STATUS; type: "default" | "subtle" }>`
  display: inline-block;
  padding: 0.1rem 0.5rem;
  border-radius: ${(props) => (props.type === "subtle" ? "0.25rem" : "1rem")};
  color: ${(props) => statusColorBadgeText[props.status]};
  background: ${(props) => statusColorBadgeBackground[props.status]};
  margin-top: 0.25rem;
  white-space: nowrap;
`;
